import React, { Component } from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import DateRangePickerButton from './DateRangePickerButton';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';

class Filter extends Component {
	constructor(props) {
		super(props);
		this.handleDateRangeSelect = this.handleDateRangeSelect.bind(this);
		this.handleRefresh = this.handleRefresh.bind(this);
	}

	getCurrentFilter() {
		const { periodFrom, periodTo, term, year } = this.props;
		return {
			periodFrom,
			periodTo,
			term,
			year
		};
	}

	handleDateRangeSelect({ periodFrom, periodTo, term, year }) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			periodFrom,
			periodTo,
			term,
			year
		});
	}

	handleRefresh() {
		this.props.onApplyFilter(this.getCurrentFilter());
	}

	render() {
		const buttonClassName = 'btn-lg btn-light-grey';

		return <ButtonToolbar className='pull-right buttons-widget'>
			<DateRangePickerButton buttonClassName={buttonClassName} currentCulture={this.props.currentCulture}
				periodFrom={this.props.periodFrom} periodTo={this.props.periodTo}
				term={this.props.term} terms={this.props.terms}
				year={this.props.year} years={this.props.years}
				activeYear={this.props.activeYear}
				onDateRangeSelect={this.handleDateRangeSelect}
			/>
			<Button className={buttonClassName} onClick={this.handleRefresh}><FontAwesomeIcon icon={faRefresh} /></Button>
		</ButtonToolbar>;
	}
}

export default withTranslation()(Filter);